import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { withCellWrapper } from '../helpers';
import { getPercentageChanceToCloseTooltip } from 'pages/CustomObjects/RecordsPage/helpers';
import { StyledInfoWrapper } from 'components/Fields/InlineTableFieldInput/styles';
import KizenTypography from 'app/kizentypo';
import WholeNumberInline from 'components/Inputs/inline/TextInput/presets/WholeNumber';
import { getAdditionalFieldProps } from 'checks/fields';
import { IconWithTooltip } from 'pages/Common/components/LinkWithIconTooltip/IconWithTooltip';

const _ChanceToCloseCell = forwardRef(
  (
    {
      field,
      entityId,
      onSubmit,
      value,
      stageValue,
      objectId: modelId,
      serviceToUse,
      fetchUrl,
      handleUpdateFieldOption,
      handleUpdateTableRecords,
      menuLeftButton,
      menuRightButton,
      placeholder: placeholderProp,
      info: infoProp,
      showDisplayNameTooltip,
      column,
      readOnly,
      editable,
      onAutoFocus,
      meta,
      supportsInfiniteScroll,
      ...others
    },
    ref
  ) => {
    const { t } = useTranslation();

    const showPlaceholder = !value && value !== 0;
    const placeholder = showPlaceholder ? stageValue : null;
    const info = showPlaceholder ? getPercentageChanceToCloseTooltip(t) : null;

    // If we support infinite scroll, we don't want to render the input because
    // react-autosize-input will cause the table to jump around as you scroll.
    // For most fields, this is automatic, but % chance to close renders the input
    // even when it's read only, so we need to handle it here.
    if (readOnly && supportsInfiniteScroll) {
      return (
        <StyledInfoWrapper>
          <KizenTypography>{value ?? placeholder}</KizenTypography>
        </StyledInfoWrapper>
      );
    }

    const isInheritedPercentage = !!(info && editable && !readOnly);

    return (
      <StyledInfoWrapper isInheritedPercentage={isInheritedPercentage}>
        <WholeNumberInline
          ref={ref}
          field={field}
          {...others}
          value={value ?? stageValue}
          onSubmit={async (data) => {
            await onSubmit(data);
          }}
          onAutoFocus={onAutoFocus}
          {...getAdditionalFieldProps(field, info, placeholder)}
          editable={editable}
          readOnly={readOnly}
        />
        {isInheritedPercentage ? <IconWithTooltip label={info} /> : null}
      </StyledInfoWrapper>
    );
  }
);

export const ChanceToCloseCell = withCellWrapper(_ChanceToCloseCell);
